import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
import { Row } from './styles/Row.styled';
import { ColumnTwo } from './styles/Column.styled';
import {
  TwoColumnImageText,
  ContentPart,
  LeftImage,
  InnerContentText,
  InnerContentUl,
  InnerContentLi,
} from './styles/FullTwoRowImageText.styled';

export default function ContentBlockWithBullets({ data, dir, id }) {
  const { title, paragraphs, image, bulletList, imageOnRight, grayBackground } = data;
  return (
    <TwoColumnImageText id={id}>
      <Row className={`no-gutters ${imageOnRight && 'right'}`}>
        <ColumnTwo className="no-gutters">
          <LeftImage className="contentblcok_bulletImg" dir={dir}>
            <h3 dir={dir} className="contentblock_title">
              {title}
            </h3>
            <LazyLoadImage
              src={_.isEmpty(image) || image.url}
              alt={_.isEmpty(image) || image.name}
              placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
              effect="blur"
            />
          </LeftImage>
        </ColumnTwo>
        <ColumnTwo className="no-gutters">
          <ContentPart className={grayBackground && 'grey'}>
            <InnerContentText dir={dir}>
              <h3 dir={dir} className="title_innercontent">
                {title}
              </h3>
              {paragraphs.map((paragraph) => (
                <p dir={dir}>{paragraph}</p>
              ))}
              <InnerContentUl>
                {bulletList.map((bullet) => (
                  <InnerContentLi dir={dir}>{bullet}</InnerContentLi>
                ))}
              </InnerContentUl>
            </InnerContentText>
          </ContentPart>
        </ColumnTwo>
      </Row>
    </TwoColumnImageText>
  );
}
